export const saveLangToLocal = (lang) => {
  localStorage.setItem('language', lang)
}
